import { WidgetProvider } from "@/context/widget-context";
import { GraphQLProvider } from "@/lib/graphql-client";
import { Suspense } from "react";
import Drawer from "./page";

export default function RootLayout() {
  return (
    <GraphQLProvider
      endpoint={
        process.env.GRAPHQL_URL || "https://fht-backend.wesence.com/graphql"
      }
    >
      <Suspense>
        <WidgetProvider>
          <Drawer />
        </WidgetProvider>
      </Suspense>
    </GraphQLProvider>
  );
}
